import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const RateContext = createContext({ rate: 83.5, loading: true });
export const useRate = () => useContext(RateContext);

export const RateProvider = ({ children }) => {
  const [rate, setRate] = useState(83.5);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/exchange-rate")
      .then((r) => { if (r.data?.usd_inr) setRate(Number(r.data.usd_inr)); })
      .catch(()=>{})
      .finally(()=>setLoading(false));
  }, []);

  return (
    <RateContext.Provider value={{ rate, loading }}>
      {children}
    </RateContext.Provider>
  );
};
